import Crud from './crud'
import { request_list } from '@/commons/hpod';
var crud = new Crud('transactions', 'mã vận đơn');

const state = {
    ...crud.state,
    selected: null
};
const getters = {
    ...crud.getters,
};
const actions = {
    ...crud.actions,
    getDetailTran({ commit }, param = {}) {
        commit("setLoading", { loading: true });
        request_list('transactions/detail', ret => {
            commit('setDetail', ret);
            commit("setLoading", { loading: false });
        }, param, null);
    },
};
const mutations = {
    ...crud.mutations,
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};